import { ApiError } from 'src/errors/ApiError';
import fetchMetadata from '@api/base/fetchMetadata';
import { logApiError, newRequestId } from '@api/base/apiLogger';
import { isVerboseDebugEnabled } from '@utils/debugMode';

declare const HIDE_NETWORK_LOGS: boolean;

export default <T>(
  client,
  method,
  request = null,
  processCallback = (data: [T, any]) => {},
  onEndCallback: (data: T[]) => void = null
): Promise<T> => {
  if (isVerboseDebugEnabled()) {
    if (HIDE_NETWORK_LOGS !== true) {
      console.group(`>> ${method.name}`);
      if (request != null) {
        if (request.toObject) {
          console.info(structuredClone(request));
        } else {
          console.info(structuredClone(request.array));
        }
      }
      console.groupEnd();
    }
  }

  return fetchMetadata().then((rawMetadata) => {
    const startedAt = performance.now();
    const requestId = newRequestId();
    const metadata = { ...rawMetadata, 'x-request-id': requestId };

    return new Promise((resolve, reject) => {
      const resData = [];
      const stream = method.call(client, request, metadata);

      stream.on('data', (res) => {
        if (processCallback) {
          processCallback([res.toObject(), stream]);
        }
        resData.push(res.toObject());
      });

      stream.on('status', (status) => {
        if (status.code !== 0) {
          const errorMessage = status.errorMessage || status.message || status.details;

          logApiError({
            methodName: method.name,
            code: status.code,
            message: errorMessage,
            requestId,
            startedAt,
            grpcMetadata: status.metadata || status.trailers,
          });

          if (isVerboseDebugEnabled()) {
            console.error(status);
          }

          reject(new ApiError(errorMessage, status.code, status, requestId));
        }
      });

      stream.on('end', () => {
        if (isVerboseDebugEnabled()) {
          if (HIDE_NETWORK_LOGS !== true) {
            console.group(`<< ${method.name}`);
            console.info(structuredClone(resData));
            console.groupEnd();
          }
        }

        if (onEndCallback) {
          onEndCallback(resData);
        }

        // @ts-ignore
        resolve(resData);
      });
    });
  });
};
